import { showNotification } from "@mantine/notifications";
import { MedplumClient, normalizeErrorString } from "@medplum/core";
import userIcon from "../../../assets/img/user.svg";
import sampleUserImg from "../../../assets/img/sampleUser.svg";
import femaleImg from "../../../assets/img/femaleSample.jpeg";
import stepsLogo from "../../../assets/img/Stepsnew.svg";
import heightLogo from "../../../assets/img/heightnew.svg";
import BMIlogo from "../../../assets/img/bminew.svg";
import weightLogo from "../../../assets/img/weightnew.svg";
import bodyTemperatureLogo from "../../../assets/img/bodytempnew.svg";
import spo2Logo from "../../../assets/img/Spo2new.svg";
import bloodGlucoseLogo from "../../../assets/img/Blood Glucosenew.svg";
import bloodPressureLogo from "../../../assets/img/Blood Pressuenew.svg";
import bodyfatpercentage from "../../../assets/img/body fat.svg";
import heartRateLogo from "../../../assets/img/HeartRatenew.svg";
import { formatXml } from "../../../utils";
export async function chatCommunicationsBot(
  medplum: MedplumClient,
  payload: any
) {
  try {
    const res = await medplum.executeBot(
      {
        system: "https://api-stage.healthconnect.systems/bots",
        value: "chat-communications",
      },
      payload
    );
    return res;
  } catch (err) {
    console.error("Unexpected error:", err);
  }
}
interface Message {
  id: string;
  text: string;
  content: any;
  sender: string;
  timestamp: string;
  avatar: string;
  person: string;
}

export const onSend = async (
  text: string,
  practiotnerId: any,
  patientId: any,
  medplum: MedplumClient,
  file?: any,
  fileTitle?: string,
  fileType?: any
) => {
  let inputMessage;
  if (file && fileTitle && fileType && text.length > 0) {
    inputMessage = {
      request: "createCommunication",
      sender: `Practitioner/${practiotnerId}`,
      recipient: `Patient/${patientId}`,
      content: text,
      attachments: [
        {
          title: fileTitle,
          data: file.replace(/^data:([a-zA-Z0-9\-\/]+);base64,/, ""),
          contentType: fileType,
        },
      ],
    };
  } else if (!file && !fileTitle && !fileType && text.length > 0) {
    inputMessage = {
      request: "createCommunication",
      sender: `Practitioner/${practiotnerId}`,
      recipient: `Patient/${patientId}`,
      content: text,
    };
  } else if (file && fileTitle && fileType && text.length <= 0) {
    inputMessage = {
      request: "createCommunication",
      sender: `Practitioner/${practiotnerId}`,
      recipient: `Patient/${patientId}`,
      attachments: [
        {
          title: fileTitle,
          data: file.replace(/^data:([a-zA-Z0-9\-\/]+);base64,/, ""),
          contentType: fileType,
        },
      ],
    };
  }

  try {
    const response = await chatCommunicationsBot(medplum, inputMessage);
    if (response.status === 200) {
      const sentMessage: Message = {
        id: response.body.id,
        text,
        content: response.body?.payload?.[1]?.contentAttachment
          ? response.body.payload[1].contentAttachment
          : response.body?.payload?.[0]?.contentAttachment,
        sender: `Practitioner/${practiotnerId}` as any,
        timestamp: new Date().toLocaleTimeString(),
        avatar: "https://ui-avatars.com/api/?name=Practitioner",
        person: "receiver",
      };
       if(response.status !==200){
      showNotification({
        color: "red",
        message: `Failed , ${response?.message}`,
        autoClose: true,
      });
    }
    else{
      showNotification({
        color: "red",
        message: `Failed , ${response?.message}`,
        autoClose: true,
      });
    }
    }
  } catch (error) {
    console.error("Error sending message:", error);
    showNotification({
      color: "red",
      message: normalizeErrorString(error),
      autoClose: true,
    });
  }
};

export const getSubscriptionToken = async (
  ids: string[],
  medplum: MedplumClient
) => {
  const tokens: string[] = [];

  for (const id of ids) {
    try {
      const response = await chatCommunicationsBot(medplum, {
        request: "getBindingToken",
        subscriptionId: id,
      });
      if (response?.status === 200) {
        const token = response.body.parameter.find(
          (param: any) => param.name === "token"
        )?.valueString;
        if (token) {
          tokens.push(token);
        }
      }
    } catch (error) {
      console.error("Error fetching subscription token:", error);
    }
  }

  return tokens;
};
export const createSubscriptionsToken = async (
  medplum: MedplumClient,
  patientId: any,
  practiotnerId: any
) => {
  const ids: string[] = [];

  try {
    const response = await chatCommunicationsBot(medplum, {
      request: "createSubscriptions",
      sender: `Patient/${patientId}`,
      recipient: `Practitioner/${practiotnerId}`,
    });
    if (response.body) {
      ids.push(response.body.outgoingSubscription.id);
      ids.push(response.body.incomingSubscription.id);
      // setSubscriptionIds(ids);
    }
  } catch (error) {
    console.error("Error creating subscription:", error);
  }
  return ids;
};

export const fetchPreviousMessages = async (
  medplum: MedplumClient,
  practiotnerId: any,
  patientId: any
) => {
  try {
    const response = await chatCommunicationsBot(medplum, {
      request: "getCommunications",
      sender: `Practitioner/${practiotnerId}`,
      recipient: `Patient/${patientId}`,
    });
    if (response?.status === 200) {
      const pastMessages = response.body.entry.map((item: any) => ({
        id: item.resource.id,
        text:
          item.resource.payload[0]?.contentString === "{EMPTY}"
            ? ""
            : item.resource.payload[0]?.contentString || "",

        sender: item.resource.sender.reference,
        content: item?.resource?.payload?.[1]?.contentAttachment
          ? item?.resource?.payload[1].contentAttachment
          : item?.resource?.payload?.[0]?.contentAttachment,
        timestamp: new Date(item.resource.sent).toLocaleTimeString(),
        date: new Date(item.resource.sent).toLocaleDateString(),
        avatar: item.resource.sender.reference.includes("Practitioner")
          ? "https://ui-avatars.com/api/?name=Practitioner"
          : "https://t3.ftcdn.net/jpg/02/17/64/02/360_F_217640276_uNPwftAgKhHALaVUgj6SFv5crXWsVAuG.jpg",
        person: item.resource.sender.reference.includes("Practitioner")
          ? "sender"
          : "receiver",
      }));
      const tempMessage = pastMessages.reverse();

      return tempMessage;
    }
  } catch (error) {
    console.error("Error fetching previous messages:", error);
    showNotification({
      color: "red",
      message: "Failed to fetch messages",
      autoClose: true,
    });
  }
};
export const getMimeTypeFromDataUrl = (dataUrl: any) => {
  const mimeType = dataUrl.match(/^data:(.*?);base64,/);
  return mimeType ? mimeType[1] : null;
};

export const handleOtherFileDownload = (
  base64String: any,
  fileName: any,
  fileType: any
) => {
  // Create a Blob from the Base64 string
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: fileType });

  // Create a link element
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;

  // Append the link to the body (required for Firefox)
  document.body.appendChild(link);

  // Simulate a click on the link
  link.click();

  // Clean up
  document.body.removeChild(link);
};
export const handleFileDownload = (
  base64String: any,
  fileName: any,
  fileType: any
) => {
  // Create a Blob from the Base64 string

  const byteCharacters = atob(base64String);

  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  // const blob = new Blob([byteArray], { type: fileType });
  let blob;
  let fileURL;
  // Generate a URL for the Blob
  // const fileURL = URL.createObjectURL(blob);
  if (base64String.startsWith("{\\rtf1\\")) {
    const blob = new Blob([byteCharacters], {
      type: "application/rtf;charset=utf-8",
    });
    const converted = parseRTF(byteCharacters);
    return converted;
  }

  // Handle different file types
  if (fileType.includes("pdf")||byteCharacters.startsWith("%pdf")) {
    blob = new Blob([byteArray], { type: "application/pdf" });

    // Generate a URL for the Blob
    fileURL = URL.createObjectURL(blob);

    // Return the URL for PDF files
    return fileURL;
  } else if (fileType.startsWith("image/" || "data:image"||byteCharacters.startsWith("data:image")||fileType.includes("jpeg"||"png"||"jpg"))) {
    // Return the URL for image files
    blob = new Blob(
      [Uint8Array.from(atob(base64String), (c) => c.charCodeAt(0))],
      { type: "image/png" }
    );
    fileName = `${fileName}.png`;
    fileType = "image";

    const url = window.URL.createObjectURL(blob);
    return url;
  } else if (fileType === "application/xml"||byteCharacters.includes("xml")) {
    // Return the Blob for RTF and XML files
    return blob;
  } else {
    blob = new Blob([byteArray], { type: fileType });

    // Generate a URL for the Blob
    fileURL = URL.createObjectURL(blob);
    // For other file types, proceed with download
    const downloadLink = document.createElement("a");
    downloadLink.href = fileURL;
    downloadLink.download = fileName;

    // Append the download link to the body (required for Firefox)
    document.body.appendChild(downloadLink);

    // Simulate a click on the download link
    downloadLink.click();

    // Clean up the download link
    document.body.removeChild(downloadLink);

    // Return the URL for completeness
    // return fileURL;
  }
};


export const vitalLogo = {
  heartrate: heartRateLogo,
  bloodpressure: bloodPressureLogo,
  bloodglucoselevel: bloodGlucoseLogo,
  bodyfatpercentage: bodyfatpercentage,
  spo2: spo2Logo,
  temperature: bodyTemperatureLogo,
  temp: bodyTemperatureLogo,
  steps: stepsLogo,
  height: heightLogo,
  weight: weightLogo,
  oxygensaturationbypulseoximetry: bloodGlucoseLogo,
  hr_max: heartRateLogo,
  bmi: BMIlogo,
  cycling: bloodGlucoseLogo,
  running: bloodGlucoseLogo,
  caloriesburned: bloodGlucoseLogo,
  insulindelivery: bloodGlucoseLogo,
} as any;

export function handleXmlFile(
  fileString: string,
  fileName: string
): Promise<string> {
  return new Promise((resolve, reject) => {
    const blob = new Blob([fileString], {
      type: "application/xml;charset=utf-8",
    });
    fileName = `${fileName}.xml`;
    const fileType = "xml";
    const reader = new FileReader();

    reader.onloadend = () => {
      if (reader.result) {
        const formattedXml = reader.result.toString();
        const formattedXmlString = formatXml(formattedXml);

        resolve(formattedXmlString);
      } else {
        reject(new Error("Failed to read the file"));
      }
    };

    reader.onerror = () => {
      reject(new Error("FileReader error"));
    };

    reader.readAsText(blob);
  });
}
export function parseRTF(rtf: string): string {
  return rtf
    .replace(/\\par[d]?/g, "<br>")
    .replace(/{\\b\s([^}]*)}/g, "<b>$1</b>")
    .replace(/\\[a-z]+\d*/g, "")
    .replace(/[\{\}\\]/g, "");
}


export const isEffectiveTimeLessThanTenMinutes = (
  effectiveDateTime: string
): string => {
  if (effectiveDateTime === "Just now") {
    return "#00a86b";
  } else {
    const effectiveDate = new Date(effectiveDateTime);
    const now = new Date();
    const timeDiffMilliseconds = now.getTime() - effectiveDate.getTime();
    const timeDiffMinutes = Math.abs(timeDiffMilliseconds / (1000 * 60));

    if (timeDiffMinutes < 10) {
      return "#00a86b";
    } else {
      return "#B1B6C0";
    }
  }
};